<template>
    <div id="index_layout">
        <div v-if="!isBegin" class="header"
            style="box-sizing: border-box;background:#ffffff;position: fixed;top:0;left:0;z-index:1000;padding-right:8%;border-bottom: 1px solid rgba(112, 112, 112, 0.2);">
            <!-- <div class="begin_header" style="display: flex;justify-content: space-between;visibility: hidden;">
                <div class="logo_img">
                    <div style="display:flex; align-items: center; float:left; height: 65px;">
                        <div class="header-logo">
                            <img id="header-img" src="../assets/hslogo.png" >
                        </div>
                    </div>
                </div>
                <div style="display:flex;font-size: 20px;">
                    <div v-for="(item, index) in titles" :key="index" @click="changeTitle(item)" style="margin-top:20px;margin-left:50px;cursor:pointer;" :style="{color:(item.value === currentRoute ? '#3fa8c7' : '#000000')}">
                        {{item.name}}
                    </div>
                </div>
            </div> -->
            <div class="begin_header" style="display: flex; justify-content: space-between;">
                <div class="logo_img" style="margin-left: 6%; margin-top:15px;">
                    <div style="display:flex; align-items: center; float:left; height: 65px; min-width: 200px">
                        <div class="header-logo" style="width: 100%; height: 65px;">
                            <img id="header-img" src="../assets/hslogo.png" style="width: 100%; height: 100%;">
                        </div>
                    </div>
                </div>
                <div style="display:flex;font-size: 20px;margin-top:10px;">
                    <div v-for="(item, index) in titles" :key="index" @click="changeTitle(item)"
                        style="margin-top:20px;cursor:pointer;"
                        :style="{ color: (item.value === currentRoute ? '#3fa8c7' : '#000000'), marginLeft: index === 0 ? '0' : '45px' }">
                        {{ item.name }}
                    </div>
                    <el-popover placement="bottom" v-if="hasLogin" width="150" trigger="hover">
                        <div @click="loginOut" style="text-align:center;dont-size:20px;cursor:pointer;">退出</div>
                        <div style="margin-top:20px;margin-left:50px;" slot="reference">退出</div>
                    </el-popover>

                    <!-- <div style="margin-top:20px;margin-left:50px;color:#3fa8c7;">root</div> -->
                </div>
            </div>
        </div>
        <div v-if="isBegin" style="width:100%;height:100%;margin-top:0px;">
            <router-view></router-view>
        </div>
        <div v-if="!isBegin" class="container" id="index" ref="appRef" style="clear: both;margin-top:130px;">
            <router-view></router-view>
            <div style="width: 100%; margin: 0px auto; margin-bottom:24px; background:#f2f3f5;">
                <div style="width: 100%; padding-top: 30px; display: flex; justify-content: center;">
                    <div style="width: 350px">
                        <img src="../assets/hslogo.png" style="width: 100%">
                    </div>
                </div>
                <div style="display:flex;justify-content:center;align-items:center;margin-top:30px;">
                    <div>
                        <img src="../assets/huishengdongtai.png" style="width: 100px;height: 100px;border: 0" />
                        <div class="footer_font" style="color:#3fa8c7;font-size:16px;text-align:center;">
                            微信公众号<br />
                            <span style="color:#999999;font-size:14px;">汇升动态</span>
                        </div>
                    </div>
                    <div style="margin-left: 50px;">
                        <img src="../assets/huishengtoujiao.png" style="width: 100px;height: 100px;border: 0" />
                        <div class="footer_font" style="color:#3fa8c7;font-size:16px;text-align:center;">
                            微信公众号<br />
                            <span style="color:#999999;font-size:14px;">汇升投教</span>
                        </div>
                    </div>
                    <div style="margin-left: 50px;">
                        <img @click="engage" src="../assets/dianjicahkan.png"
                            style="width: 100px;height: 100px;border: 0" />
                        <div class="footer_font" style="color:#3fa8c7;font-size:16px;text-align:center;">
                            <span @click="engage" style="cursor:pointer;">点击查看</span><br />
                            <span style="color:#999999;font-size:14px;">在招岗位</span>
                        </div>
                    </div>
                </div>
                <div
                    style="width:60%;font-size:18px;margin:0 auto;padding-top:20px;display:flex;justify-content: space-between;margin-top:20px;border-top:1px solid #d0d0d0;">
                    <div v-for="(item, index) in titles" :key="index" @click="changeTitle(item)"
                        style="color:#333333;font-size:18px;cursor:pointer;">
                        {{ item.name }}
                    </div>
                </div>
                <div style="color:#999999;font-size:14px;margin-top:30px;padding-bottom:26px;text-align:center;">
                    版权所有：江苏苏豪汇升私募基金管理有限公司 <a style="color: #333333;text-decoration: revert;cursor:pointer;"
                        @click="handleJump('https://beian.miit.gov.cn/#/Integrated/index')">苏ICP备17063410号-1</a>
                </div>
            </div>
        </div>

        <!-- <div v-if="!isBegin" style="width: 90%;margin: 20px auto;">
            <div v-if="!isBegin" style="height:1px;padding:0;background-color:#f8f8f8;">
            </div>
        </div> -->
        <!-- <div v-if="!isBegin" id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div> -->
    </div>
</template>

<script>
import drawMixin from "../utils/drawMixin";
import $ from "jquery";
import { logout } from '@/api/index'
export default {
    name: "Layout",
    mixins: [drawMixin],
    data() {
        return {
            activeIndex: '1',
            hasLogin: localStorage.getItem('token'),
            isBegin: false,
            scroll: '',
            timer: '',
            seen: true,
            currentMenu: '首页',
            currentRoute: '',
            titles: [{
                name: '首页',
                value: '/index'
            }, {
                name: '走进汇升',
                value: '/enterHS'
            }, {
                name: '汇升文化',
                value: '/hsCulture'
            }, {
                name: '汇升投教',
                value: '/hsInvestEducation'
            }, {
                name: '汇升招聘',
                value: '/hsEngage'
            }],
            // , {
            //     name: '汇升登录',
            //     value: '/login'
            // }
        };
    },
    watch: {
        $route: {
            handler: function (route) {
                this.currentRoute = route.fullPath
                if (route.name === "Begin") {
                    this.isBegin = true // 刚进来 true
                } else {
                    this.isBegin = false
                    // console.log('1111111')
                    if (route.name === "Index") {
                        // location.reload();
                    }
                }

                if (localStorage.getItem('token')) {
                    this.titles = [{
                        name: '首页',
                        value: '/index'
                    }, {
                        name: '走进汇升',
                        value: '/enterHS'
                    }, {
                        name: '汇升文化',
                        value: '/hsCulture'
                    }, {
                        name: '汇升投教',
                        value: '/hsInvestEducation'
                    }, {
                        name: '汇升招聘',
                        value: '/hsEngage'
                    }, {
                        name: '汇升动态管理',
                        value: '/systemManage'
                    }, {
                        name: '汇升投研管理',
                        value: '/loveholicManage'
                    }]
                } else {
                    this.titles = [{
                        name: '首页',
                        value: '/index'
                    }, {
                        name: '走进汇升',
                        value: '/enterHS'
                    }, {
                        name: '汇升文化',
                        value: '/hsCulture'
                    }, {
                        name: '汇升投教',
                        value: '/hsInvestEducation'
                    }, {
                        name: '汇升招聘',
                        value: '/hsEngage'
                    }]
                    // , {
                    //     name: '汇升登录',
                    //     value: '/login'
                    // }
                }
                this.hasLogin = localStorage.getItem('token')
            },
            immediate: true
        }
    },
    methods: {
        changeTitle(item) {
            this.currentRoute = item.value
            const str = window.location.hash;
            const pageName = str.slice(2, str.length)
            if (item.value === '/hsEngage' && pageName === 'hsEngage') {
                this.$router.go(0);
            } else {
                this.$router.push({
                    path: item.value,
                    // query: {
                    //     id: this.roleId,
                    //     ids: this.checkList
                    // }
                })
            }
        },
        handleSelect(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: "Index" });
                    break;
                case '2-1':
                    window.location.hash = "#产品微观";
                    break;
                case '2-2':
                    this.$router.push({ name: "Fruit" });
                    break;
                case '2-3':
                    this.$router.push({ name: "Fashion" });
                    break;
                case '3':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#产品特点";
                    break;
                case '4':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#合作伙伴";
                    break;
                case '5':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#关于我们";
                    break;
            }
        },
        handleSelectMobile(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: "Index" });
                    this.currentMenu = '首页';
                    break;
                case '2-1':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#产品微观";
                    this.currentMenu = '首页';
                    break;
                case '2-2':
                    this.$router.push({ name: "Fruit" });
                    this.currentMenu = '生鲜果蔬';
                    break;
                case '2-3':
                    this.$router.push({ name: "Fashion" });
                    break;
                case '3':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#产品特点";
                    this.currentMenu = '首页';
                    break;
                case '4':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#合作伙伴";
                    this.currentMenu = '首页';
                    break;
                case '5':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#关于我们";
                    this.currentMenu = '首页';
                    break;
            }
        },
        handleScroll() {
            this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            if (this.scroll > 600) {  //判断滚动后高度超过400px,就显示
                this.$refs.btn.style.display = 'block';
            } else {
                this.$refs.btn.style.display = 'none'
            }
        },
        backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 30)
        },
        engage() {
            this.$router.push({ name: "hsEngage" });
        },
        handleJump(url) {
            window.open(url)
        },
        login() {
            window.open('https://admin.fastice-tech.com/login')
        },
        register() {
            window.open('https://admin.fastice-tech.com/registe')
        },
        menuSeen() {
            // 屏幕尺寸
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                this.seen = true;
            } else {
                this.seen = false;
            }
        },
        logoClick() {
            this.$router.push({ name: "Index" });
            this.currentMenu = '首页';
        },
        loginOut() {
            logout({})
                .then(res => {
                    localStorage.removeItem('token')
                    this.$router.push({ path: "/login" });
                })
        }
    },
    mounted() {
        $(document).ready(function () {
            var whei = $(window).width();
            $("html").css({ fontSize: whei / 20 });
            $(window).resize(function () {
                var whei = $(window).width();
                $("html").css({ fontSize: whei / 20 });
            });
        });
        console.log('dwadadwawdad')
        this.menuSeen()
        window.addEventListener('scroll', this.handleScroll)
    },
}
</script>
<style>
html,
body {
    width: 100%;
    height: 100%;
    margin: 0;
}

#index {
    width: 2100px;
    height: 1080px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    -webkit-transform-origin: left top;
    transform-origin: left top;
}
</style>
<style scoped>
.logo_img {
    float: left;
    width: 20%;
    cursor: pointer;
}

#back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer
}

.header-title {
    font-size: 1em;
}

.company_name {
    font-weight: normal;
    font-size: 1em;
}

.footer_font {
    font-size: 1em;
}

#menu_index {
    float: left;
    width: 50%;
    height: 100%
}

.header {
    margin: auto;
    width: 100%;
    height: 130px;
    padding: 20px;
    /*background: #F56C6C;*/
}

@media screen and (max-device-width: 415px) {
    .logo_img {
        float: left;
        width: auto;
        cursor: pointer;
    }

    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer
    }

    .footer_font {
        font-size: 0.875em;
    }

    #menu_index {
        float: right;
        width: auto;
        height: 100%
    }

    .mobile_menu {}
}

#header-img {
    width: auto;
    height: 40px;
    float: left;
    margin: auto;
}

.header-logo {
    height: 50px;
    width: 50px;
    align-self: center;
}

.header-important {
    float: left;
    margin-left: 6px;
    align-self: center;
}

.footer {
    display: flex;
    align-items: center;
    margin: 10px auto;
    width: 90%;
}

a {
    text-decoration: none;
}

a:visited {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

a:active {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue